import {combineReducers}  from "redux"
import Budgets            from "./Budgets"

const Facebook = combineReducers({
  Budgets,
})

export default Facebook
